import { type FC } from 'react'

import { ErrorBoundary } from '@/components/shared/error-boundary'
import { LoggedInLinks } from '@/components/shared/global-header/tools/logged-in-links'
import { LoggedOutLinks } from '@/components/shared/global-header/tools/logged-out-links'
import { SessionMenu } from '@/components/shared/global-header/tools/session-menu'
import { ToolsContainer } from '@/components/shared/global-header/tools/styled'
import { PostAdCTA } from '@/components/shared/post-ad/PostAdCTA'
import { TRANSLATION_KEYS } from '@/constants/localization'
import { ROUTES } from '@/constants/routes'
import { useSession } from '@/features/auth/hooks/useSession'
import { GA_CTA_HEADER } from '@/lib/ga/constants/ga'

type ToolsProps = {
  showPostAdCTA: boolean
}

export const Tools: FC<ToolsProps> = ({ showPostAdCTA }) => {
  const { optimisticIsAuthenticated } = useSession()

  return (
    <ToolsContainer data-testid="global-header-tools">
      <ErrorBoundary fingerprintId="Tools">
        {optimisticIsAuthenticated ? (
          <>
            <LoggedInLinks />
            <SessionMenu />
          </>
        ) : (
          <LoggedOutLinks />
        )}
      </ErrorBoundary>

      {showPostAdCTA && (
        <PostAdCTA
          namespace={TRANSLATION_KEYS.GLOBAL_HEADER}
          postAdGAEventLabel={GA_CTA_HEADER}
          testId="header-link-post-ad"
          translationContentKey="links.post_ad.label"
          callbackUrl="/p-select-category.html"
          route={ROUTES.POST_AD}
        />
      )}
    </ToolsContainer>
  )
}
